// extracted by mini-css-extract-plugin
module.exports = {"quote":"styles_quote__pfB5O"};